// oxlint-disable-next-line no-restricted-imports
import { useSelector as useReduxSelector } from 'react-redux';

import type { GlobalState } from '#reducers/state';

export function useSelector<TState = GlobalState, TSelected = unknown>(
  selector: (state: TState) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean,
) {
  return useReduxSelector<TState, TSelected>(selector, equalityFn);
}
